require('./dropdownInterveners.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

class IntervenerItemOptions extends React.Component {
    constructor() {
        super();
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render () {
        const { option, className } = this.props;
        const intervener = option;
        const id = `${intervener.id}_Options_${intervener.value}`;
        const intervenerClass = `${className} dropdown-interveners__intervener row no-outside-gutter`;

        return (
            <div
                id={id}
                className={intervenerClass}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
            >
                <div className="dropdown-interveners__intervener-description dropdown-interveners__intervener-description--dropdown-list">
                    <span className="dropdown-interveners__intervener-description-name">{intervener.name}</span>
                    <span className="dropdown-interveners__intervener-description-intervention-type">{intervener.interventionType}</span>
                </div>
            </div>
        );
    }
}

IntervenerItemOptions.propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    option: PropTypes.object,
    onFocus: PropTypes.func,
    isFocused: PropTypes.bool
};

module.exports = IntervenerItemOptions;
